const sections = [
  { id: 'section1', title: 'Section I: The Cosmos' },
  { id: 'section2', title: 'Section II: The Constellian Alliance' },
  { id: 'section3', title: 'Section III: Arkhalion' },
  { id: 'section4', title: 'Section IV: Organizations & Military' },
  { id: 'section5', title: 'Section V: Characters & Heroes' },
  { id: 'sectionA', title: 'Appendix' }
];


export default sections;